import { defineMessages } from 'react-intl';

export default defineMessages({
    import: {
        id: 'quoteandbind.ImportToSpreadSheetModal.import',
        defaultMessage: 'Import'
    },
    close: {
        id: 'quoteandbind.ImportToSpreadSheetModal.close',
        defaultMessage: 'Close'
    },
});
